import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ValidateComponent } from '../../components/common/validateComponent/validate.component';
import { RegistrationService } from '../../services/registration.service';
import { RegistrationFirstStepModel, AddressLookupResult, CapturedAddress } from '../../models/registration/registration.models';
import { Address } from '../../models/common/address';
import {Configuration} from '../../configuration';

@Component({
    selector: 'registration-details',
    template: require('./registration.details.component.html'),
    styles: [require('./registration.details.component.css')]
})
export class RegistrationDetailsComponent extends ValidateComponent {
    @Input() request: RegistrationFirstStepModel;
    @Input() registrationService: RegistrationService;

    @Output() submitRequest = new EventEmitter<any>();

    postcode: string;

    showFullAddress = false;
    multipleAddresses = false;
    addressChoices: Array<CapturedAddress>;

    selectedAddress: CapturedAddress;

    @ViewChild('validateForm', { static: false }) currentForm;

    constructor(private readonly config: Configuration) {
        super();
        
        this.formErrors = {
            'firstName': '',
            'lastName': '',
            'emailAddress': '',
            'password': '',
            'confirmPassword': '',
            'companyName': '',
            'contactNumber': '',
            'address': '',
            'postcode': '',
            'tAndCsAgreed': ''
        };

        this.validationMessages = {
            'firstName': {
                'required': 'First Name is required.'
            },
            'lastName': {
                'required': 'Last Name is required.'
            },
            'emailAddress': {
                'required': 'Email address is required.',
                'pattern': 'Must be a valid email address.'
            },
            'password': {
                'required': 'Password is required.',
                'pattern': 'Password is not valid.'
            },
            'companyName': {
                'required': 'Company Name is required.'
            },
            'contactNumber': {
                'required': 'Contact Number is required.'
            },
            'confirmPassword': {
                'validateEqual': 'Passwords do not match.'
            }
        }
    }

    addressLookup() {
        this.formErrors['postcode'] = null;

        if (!this.postcode || this.postcode.length < 5) {
            this.formErrors['postcode'] = 'Please input your full postcode.';
            return;
        }

        this.registrationService.addressLookup(this.postcode)
            .subscribe((response: AddressLookupResult) => {
                this.processLookupResults(response);
            });
    }

    private processLookupResults(lookupResult: AddressLookupResult) {
        this.formErrors['address'] = null;

        if (lookupResult.capturedAddresses && lookupResult.capturedAddresses.length > 1) {
            this.addressChoices = lookupResult.capturedAddresses;
            this.multipleAddresses = true;
        } else if (lookupResult.retrievedAddress) {
            this.request.address.postcode = lookupResult.retrievedAddress.postcode;
            this.request.address.city = lookupResult.retrievedAddress.city;
            this.request.address.line2 = lookupResult.retrievedAddress.line2;
            this.request.address.line1 = lookupResult.retrievedAddress.line1.trim();

            this.showFullAddress = true;
        }

    }

    resetAddressLookup() {
        this.request.address.line1 = null;
        this.request.address.line2 = null;
        this.request.address.city = null;
        this.request.address.postcode = null;
        this.postcode = null;

        this.selectedAddress = null;
        this.addressChoices = null;

        this.multipleAddresses = false;
        this.showFullAddress = false;
    }

    selectAddress() {
        this.registrationService.addressRetrieval(this.selectedAddress.id)
            .subscribe((response: Address) => {
                this.request.address.line1 = response.line1;
                this.request.address.line2 = response.line2;
                this.request.address.city = response.city;
                this.request.address.postcode = response.postcode;

                this.multipleAddresses = false;
                this.showFullAddress = true;
                this.selectedAddress = null;
                this.addressChoices = null;
            });
    }

    enterAddressManually() {
        this.multipleAddresses = false;
        this.showFullAddress = true;
        this.addressChoices = null;
        this.selectedAddress = null;
    }

    checkEmailAddress() {

        if (this.config.environmentInfo.environmentName === 'Live') {

            this.registrationService.checkValidEmail(this.request.emailAddress)
                .subscribe((response: any) => {
                    if (response.success) {
                        document.getElementById("emailAddress").parentElement.classList.remove('invalid');
                        document.getElementById("emailAddress").parentElement.classList.add('valid');
                    }
                    else {
                        document.getElementById("emailAddress").parentElement.classList.remove('valid');
                        document.getElementById("emailAddress").parentElement.classList.add('invalid');
                        this.formErrors['emailAddress'] = 'Please enter a valid email address.';
                    }
                });
        }
        else {
            document.getElementById("emailAddress").parentElement.classList.remove('invalid');
            document.getElementById("emailAddress").parentElement.classList.add('valid');
        }        
    }

    onSubmit() {
        this.removeErrors();

        var errors = false;

        if (!this.request.tAndCsAgreed) {
            this.formErrors['tAndCsAgreed'] = 'You must agree to the terms and conditions.';
            errors = true;
        }

        if (!this.showErrors(true)) {
            errors = true;
        }

        if (!this.request.address.isPopulated()) {
            this.formErrors['address'] = 'Address is required.';
            errors = true;
        }

        if (this.request.password !== this.request.confirmPassword) {
            this.formErrors['confirmPassword'] = 'Passwords do not match.';
            errors = true;
        }

        if (document.getElementsByClassName('invalid').length > 0 ) {
            this.formErrors['emailAddress'] = 'Please enter a valid email address.';
            errors = true;
        }

        if (errors) {
            return;
        }

        this.submitRequest.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/registration.details.component.ts